import { P, S, T } from '../../../styles/tokens';

type CheckRowStatus = 'done' | 'fail' | 'pending';

interface CheckRowProps {
  text: string;
  status: CheckRowStatus;
}

const DOT_COLORS: Record<CheckRowStatus, string> = {
  done: P.success,
  fail: P.error,
  pending: P.warn,
};

/**
 * Status row with coloured dot + text. Used in verdict screens
 * to list reject reasons or check results.
 * Pattern: matches Bullets.tsx (BulletGood/BulletBad) layout.
 */
export function CheckRow({ text, status }: CheckRowProps) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
      <div
        style={{
          width: 6,
          height: 6,
          borderRadius: 3,
          background: DOT_COLORS[status],
          marginTop: 7,
          flexShrink: 0,
        }}
      />
      <div style={{ flex: 1, font: T.footnote, color: S.label, lineHeight: 1.5 }}>
        {text}
      </div>
    </div>
  );
}
